import { FormValues } from '@/containers/ConfigurePage/components/FormConfig/formData';
import { TransformedAssetCategoryResult } from '@/types/TransformedAssetCategoryResults';
import {
  ProductSubscriptionByRegionResponse,
  SubscriptionType,
} from '@/utils/fetch/fetchProductSubscriptionByRegion';
import { getCurrentSubscriptionIsFlexible } from './getCurrentSubscriptionDuration';
import { getCurrentSubscriptionType } from './getCurrentSubscriptionType';

interface SelectedSubscription {
  currentFormValues: Partial<FormValues>;
  subscriptions: ProductSubscriptionByRegionResponse;
  product: TransformedAssetCategoryResult;
}

export const getSelectedSubscription = ({
  currentFormValues,
  product,
  subscriptions,
}: SelectedSubscription): SubscriptionType | undefined => {
  const currentType = getCurrentSubscriptionType(currentFormValues, product);
  const isFlexible = getCurrentSubscriptionIsFlexible(
    currentFormValues.durationMonths
  );

  const currentSubs = subscriptions.filter(
    item =>
      item.customerType === currentType &&
      item.isFlexible === isFlexible &&
      item.minDurationMonths === Number(currentFormValues.durationMonths)
  );

  if (currentSubs.length > 1) {
    return currentSubs.filter(item => item.isSpecialOffer)[0];
  }
  return currentSubs[0];

  // find the subscription that matches the form values, if a specialOffer exists use that sub instead as SubscriptionType;
};
